import ReactGA from 'react-ga4'

interface TrackEventInterface {
    category: string // Exemplu: 'User'
    action: string // Exemplu: 'Clicked Button'
    label?: string // Exemplu: 'Home Page'
    value?: number // Exemplu: 2
}

export const trackEvent = ({
    category,
    action,
    label,
    value,
}: TrackEventInterface) => {
    ReactGA.event({
        category,
        action,
        label,
        value,
    })
}
